import { Modal } from "@mui/material";
import React, { useEffect, useState } from "react";
import styles from "./Charges.module.css";
import { Close } from "@mui/icons-material";
import { getCharges } from "../../../../Services/BuySell/Payments";
import { useSelector } from "react-redux";
import {
  consumerCharges,
  generatorCharges,
} from "../../../../Services/Payments/PaymentApi";

const Charges = ({ open, onClose, contractId, userLevel, userType }) => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({});
  const mainScreenMatchData = useSelector(
    (state) => state?.CapacitySlice?.mainScreenActiveConnection,
  );

  const user = useSelector(
    (state) => state?.persistedReducer?.userType,
  )?.toLowerCase();

  const isTrader = useSelector((state) => state?.persistedReducer);
  const userEntity = isTrader?.user?.isUserEntity;

  const id = useSelector(
    (state) =>
      state?.persistedReducer?.user[
        user === "consumer" ? "activeConsumerId" : "activeGeneratorId"
      ],
  );

  const matchedEntry = Array.isArray(mainScreenMatchData)
    ? mainScreenMatchData.find((entry) => entry?.id === contractId)
    : null;

  const fetchCharges = React.useCallback(async () => {
    try {
      if (userLevel) {
        setLoading(true);
        if (user === "consumer") {
          let payload = { consumerIds: [id] };
          let res = await consumerCharges(payload);
          if (res?.data?.code === 200) {
            const filteredConsumerCharges = (
              res?.data?.data?.[0]?.charges || []
            ).filter(
              (ele) =>
                ele?.frequency !== "ONE_TIME" &&
                (userEntity ? ele?.name !== "Trader Margin" : true),
            );
            setData({ consumerCharges: filteredConsumerCharges });
          }
        }
        if (user === "generator") {
          let payload = { generatorIds: [id] };
          let res = await generatorCharges(payload);
          if (res?.data?.code === 200) {
            const filteredGeneratorCharges = (
              res?.data?.data?.[0]?.charges || []
            ).filter(
              (ele) =>
                ele?.frequency !== "ONE_TIME" &&
                (userEntity ? ele?.name !== "Trader Margin" : true),
            );
            setData({ generatorCharges: filteredGeneratorCharges });
          }
        }
      } else {
        setLoading(true);
        const charges = await getCharges(contractId);
        const responseData = charges?.data?.data || {};

        // Filter ONE_TIME from both consumerCharges and generatorCharges
        // Also filter "Trader Margin" when userEntity is true
        const filteredData = {
          ...responseData,
          consumerCharges: (responseData?.consumerCharges || []).filter(
            (ele) =>
              ele?.frequency !== "ONE_TIME" &&
              (userEntity ? ele?.name !== "Trader Margin" : true),
          ),
          generatorCharges: (responseData?.generatorCharges || []).filter(
            (ele) =>
              ele?.frequency !== "ONE_TIME" &&
              (userEntity ? ele?.name !== "Trader Margin" : true),
          ),
        };
        setData(filteredData);
      }
    } catch (error) {
      console.error("Error fetching charges:", error);
    } finally {
      setLoading(false);
    }
  }, [contractId, id, user, userLevel, userEntity]);

  useEffect(() => {
    fetchCharges();
  }, [fetchCharges]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="child-modal-title"
      aria-describedby="child-modal-description"
    >
      <div className={`popupModal ${styles.modalMainChargeSelection}`}>
        <div className="modalHeading">
          <div
            style={{
              color: "var(--fourth-color-text)",
            }}
          >
            Charge Finalization
          </div>
          <Close
            onClick={onClose}
            style={{ cursor: "pointer" }}
            alterbutton="false"
          />
        </div>
        <div className={styles.chargeMainElemCont}>
          <div className={`display_flex_row tableHeading`}>
            <div style={{ textAlign: "left" }}>Charge Name</div>
            <div style={{ width: "10%" }}>Assignee</div>

            <div style={{ width: "15%" }}>Charge Type</div>
            <div style={{ width: "20%" }}>Value</div>
            <div style={{ width: "10%" }}>Type</div>
          </div>

          {!loading && data != null && (
            <div
              style={{ backgroundColor: "#dedfea" }}
              className={` ${styles.chargeHeight}`}
            >
              <div>
                <div
                  style={{ backgroundColor: "#52888f" }}
                  className={"display_flex_row tableDetails"}
                >
                  <div
                    style={{
                      textAlign: "left",
                      color: "white",
                      fontWeight: 600,
                    }}
                  >
                    Self Charges
                  </div>
                </div>

                {data && (
                  <>
                    {data[
                      user === "consumer"
                        ? "consumerCharges"
                        : "generatorCharges"
                    ]?.length > 0 ? (
                      data[
                        user === "consumer"
                          ? "consumerCharges"
                          : "generatorCharges"
                      ]?.map((ele, index) => {
                        // Removed redundant ONE_TIME check — already filtered at fetch time
                        return (
                          <div
                            className={"display_flex_row tableDetails"}
                            key={index}
                          >
                            <div
                              title={ele?.name || "-"}
                              style={{
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textAlign: "left",
                              }}
                            >
                              {ele?.name || "-"}
                            </div>
                            <div style={{ width: "10%" }}>{"Self"}</div>
                            <div style={{ width: "15%" }}>
                              {ele?.chargeType || "-"}
                            </div>
                            <div
                              style={{ width: "20%" }}
                              className={styles.valueInputCont}
                            >
                              {ele?.value}
                            </div>
                            <div style={{ width: "10%" }}>
                              {ele?.type === "PER_MW" ? "₹/kWh" : ele?.type}
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div
                        style={{
                          textAlign: "center",
                          width: "100%",
                          padding: "12px 0",
                        }}
                      >
                        No data
                      </div>
                    )}
                  </>
                )}
              </div>
              {/* counter charges */}
              {(() => {
                const counterCharges = data?.[
                  user === "consumer" ? "generatorCharges" : "consumerCharges"
                ]?.filter(
                  (ele) =>
                    ele?.chargeType !== "Platform" &&
                    ele?.chargeType !== "Trader"
                );
                if (!counterCharges?.length) return null;
                return (
                  <div style={{ margin: "10px 0px" }}>
                    <div
                      style={{ backgroundColor: "#52888f" }}
                      className={"display_flex_row tableDetails"}
                    >
                      <div
                        style={{
                          color: "white",
                          fontWeight: 600,
                        }}
                      >
                        Counter Party Charges
                      </div>
                    </div>
                    {counterCharges.map((ele, index) => (
                      <div
                        className={"display_flex_row tableDetails"}
                        key={index}
                      >
                        <div>{ele?.name || "-"}</div>
                        <div
                          style={{
                            width: "10%",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                          title={
                            matchedEntry?.[
                              user === "consumer"
                                ? "capacityGenerator"
                                : "capacityConsumer"
                            ][
                              user === "consumer"
                                ? "generatorName"
                                : "consumerName"
                            ] || "-"
                          }
                        >
                          {matchedEntry?.[
                            user === "consumer"
                              ? "capacityGenerator"
                              : "capacityConsumer"
                          ][
                            user === "consumer"
                              ? "generatorName"
                              : "consumerName"
                          ] || "-"}
                        </div>
                        <div style={{ width: "15%" }}>
                          {ele?.chargeType || "-"}
                        </div>
                        <div
                          style={{ width: "20%" }}
                          className={styles.valueInputCont}
                        >
                          {ele?.value}
                        </div>
                        <div style={{ width: "10%" }}>
                          {ele?.type === "PER_MW" ? "₹/kWh" : ele?.type}
                        </div>
                      </div>
                    ))}
                  </div>
                );
              })()}
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default Charges;
